// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3KBAH","consentsList":"PatientConsents_consentsList__2ZgdD","consentsListEmpty":"PatientConsents_consentsListEmpty__3z2tG"};